import { combineReducers } from 'redux';

import posts from './post';

export default combineReducers({
    posts,
});
